import o from "styled-components";
const e = o.footer`
  align-items: center;
  display: flex;
  padding: 0 16px 20px;
`, i = o.div`
  flex-basis: 50%;
`, s = o.div`
  flex-basis: 50%;
`;
export {
  e as Footer,
  i as FooterLeft,
  s as FooterRight
};
